import { createSelector } from 'reselect';
import { JOB_STATUSES, FAI_STATUS } from 'lib/constants';
import { getOffline } from './getOffline';
import { getIsAgentConnected } from './getIsAgentConnected';
import { getUnavailableStartAt } from './getUnavailableStartAt';
import { getFaultStartAt } from './getFaultStartAt';
import { getStatusLabel } from './getStatusLabel';
import { getIsPaused } from './getIsPaused';
import { getJobStatus } from './getJobStatus';
import { getFAICurrentInspection } from './getFAICurrentInspection';
import { getFAIEnabled } from './getFAIEnabled';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getIsSetupModeActive } from './getIsSetupModeActive';

export const getMachineHeaderVariant = createSelector(
  [
    getOffline,
    getIsAgentConnected,
    getUnavailableStartAt,
    getFaultStartAt,
    getStatusLabel,
    getIsPaused,
    getJobStatus,
    getFAIEnabled,
    getFAICurrentInspection,
    getIsApmERPJobFlow,
    getIsSetupModeActive,
  ],
  (
    offline,
    isAgentConnected,
    unavailableStartAt,
    faultStartAt,
    status,
    isPaused,
    jobStatus,
    faiEnabled,
    currentInspection,
    isApmERPJobFlow,
    isSetupModeActive
  ) => {
    const fault = !!faultStartAt;

    if (offline || !isAgentConnected || unavailableStartAt) {
      return 'unavailable';
    }

    if (isApmERPJobFlow && isSetupModeActive) {
      return 'setup';
    }

    if (faiEnabled && currentInspection) {
      const faiStatus = currentInspection?.status;
      if (faiStatus === FAI_STATUS.IN_PROGRESS) {
        return 'inspecting';
      }
      if (faiStatus === FAI_STATUS.PENDING) {
        return 'pending';
      }
      if (faiStatus === FAI_STATUS.REJECTED) {
        return 'rejected';
      }
    }

    if (isPaused) {
      return 'pause';
    }
    if (jobStatus === JOB_STATUSES.SETUP) {
      return 'setup';
    }
    if (fault) {
      return 'fault';
    }
    return status;
  }
);
